import monitoringHostService from './monitoringHostService.js';

angular
    .module('signalview.upgradeSubscription', [])
    .service('monitoringHostService', monitoringHostService);
